import React from 'react';
import { AlertCircle } from 'lucide-react';
export function AlertBanner() {
  return <div className="mb-6 p-4 bg-purple-50 border border-purple-200 rounded-lg flex items-center gap-3" data-id="element-11">
      <AlertCircle className="w-5 h-5 text-purple-600" data-id="element-12" />
      <p className="text-sm text-purple-700" data-id="element-13">
        3 wine labels require review for TTB compliance
      </p>
    </div>;
}